export default __webpack_public_path__ + "static/media/2.4cc33613.jpg";